;(function (tests) {
  "use strict"

  function amplitudeABTestIdentify() {
    if (tests) {
      const identity = new amplitude.Identify()

      Object.keys(tests).forEach((testName) => {
        const value = tests[testName].value
        let name = testName
        if (tests[testName].version > 0) {
          name = `${name}:${tests[testName].version}`
        }
        if (value !== "none") {
          identity.set(name, value)
        }
      })

      amplitude.getInstance().identify(identity)
    }
  }

  if (typeof amplitude !== "undefined") {
    amplitudeABTestIdentify()
  }
})(window.ab_tests)
